<template lang='pug'>
	.contenido-imagen-mayor
		.contenedor-pleca-contenido
			.contenido
				.modulo.m1
					.contedor-imagen
						img.img(src='~Img/DoIt-01.png')
				.modulo.m2
					h1
						| You are in control of fine-tuning your design
					p.caja-texto1
						| We let you specify the preferred corrective actions that you would like us to implement if your project is not under compliance as submitted. In 90% of the cases, the project will be brought into compliance when applying the corrective actions of your choice.
						br
						br
						| In the even that your project is still not under compliance even after taking into account the corrective actions that you specified, one of our Certified Energy Analysts will get in touch with you to discuss other corrective actions needed to make the design comply with the Title 24 regulations.
						br
						br
						| Our sweeping knowledge of architecture and construction will help you make the right decisions to save money and hassle.
</template>
<script>
export default {
	name: 'big-image'
}
</script>



// WEBPACK FOOTER //
// src/components/doit/contentBigImage.vue